import React from "react";
import useStyles from "./styles";
import { Box, Grid } from "@material-ui/core";
import 'react-loading-skeleton/dist/skeleton.css'
import VisionSkeleton from "./VisionSkeleton";

const VisionCarousel = () => {
  const classes = useStyles();

  return (
    <Box className={classes.carouselSkeleton}>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <VisionSkeleton />
        </Grid>
        <Grid item xs={4}>
          <VisionSkeleton />
        </Grid>
        <Grid item xs={4}>
          <VisionSkeleton />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VisionCarousel;
